import { useNavigate } from 'react-router-dom';

const MobileCallBar = () => {
  const navigate = useNavigate();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden">
      {/* Safe area padding for devices with home bars */}
      <div className="bg-white border-t border-[#E2E8F0] px-4 py-3 pb-safe flex items-center gap-3"
        style={{ paddingBottom: 'max(12px, env(safe-area-inset-bottom))' }}
      >
        <a
          href="tel:+18506698335"
          className="flex-1 flex items-center justify-center gap-2 bg-[#0C2340] text-white py-3 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-phone-fill text-sm text-[#C41E3A]" />
          </div>
          <span>(850) 669-8335</span>
        </a>
        <button
          onClick={() => navigate('/book-appointment')}
          className="flex-1 flex items-center justify-center gap-2 bg-[#C41E3A] text-white py-3 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-[#A01830] transition-colors"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-calendar-check-line text-sm" />
          </div>
          <span>Book Now</span>
        </button>
      </div>
    </div>
  );
};

export default MobileCallBar;
